import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { GradientConfig } from 'src/app/app-config';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ConfigurationComponent implements OnInit {
  scroll = (): void => {
    if (document.querySelector('.pcoded-navbar')?.hasAttribute('style')) {
      document.querySelector('.pcoded-navbar.menupos-fixed')?.removeAttribute('style');
    }
  };

  // life cycle event
  ngOnInit() {
    this.setLayout();
    this.setHeaderBackground(GradientConfig.header_back_color);
    document.querySelector('body')?.classList.remove('gradient-rtl');
    this.changeMenuFixedLayout(GradientConfig.nav_fixed_layout);
    this.changeHeaderFixedLayout(GradientConfig.header_fixed_layout);
    this.changeBoxLayout(GradientConfig.isBoxLayout);
  }

  // change main layout
  setLayout() {
    const layout = GradientConfig.layoutType;
    document.querySelector('.pcoded-navbar')?.classList.remove('menu-light');
    document.querySelector('.pcoded-navbar')?.classList.remove('menu-dark');
    document.querySelector('.pcoded-navbar')?.classList.remove('navbar-dark');
    document.querySelector('.pcoded-navbar')?.classList.remove('brand-dark');
    document.querySelector('body')?.classList.remove('gradient-dark');
    this.setHeaderBackground('header-blue');
    document.querySelector('.pcoded-navbar')?.classList.add(layout);
  }

  reset() {
    document.querySelector('.pcoded-navbar')?.classList.remove('icon-colored');
    this.ngOnInit(); // life cycle event
  }

  setMenuFixedLayout(e: Event) {
    const flag = (e.target as HTMLInputElement).checked;
    this.changeMenuFixedLayout(flag);
  }

  changeMenuFixedLayout(flag: boolean) {
    setTimeout(() => {
      if (flag) {
        document.querySelector('.pcoded-navbar')?.classList.remove('menupos-static');
        document.querySelector('.pcoded-navbar')?.classList.add('menupos-fixed');
        if (GradientConfig.layout === 'vertical') {
          (document.querySelector('#nav-ps-gradient-able') as HTMLElement).style.maxHeight = 'calc(100vh - 56px)'; // calc(100vh - 70px)
        }
        window.addEventListener('scroll', this.scroll, true);
        window.scrollTo(0, 0);
      } else {
        document.querySelector('.pcoded-navbar')?.classList.add('menupos-static');
        document.querySelector('.pcoded-navbar')?.classList.remove('menupos-fixed');
        if (GradientConfig.layout === 'vertical') {
          (document.querySelector('#nav-ps-gradient-able') as HTMLElement).style.maxHeight = 'calc(100%)'; // calc(100% - 70px)
        }
        if (GradientConfig.layout === 'vertical') {
          window.removeEventListener('scroll', this.scroll, true);
        }
      }
    }, 100);
  }

  setHeaderFixedLayout(e: Event) {
    const flag = (e.target as HTMLInputElement).checked;
    this.changeHeaderFixedLayout(flag);
  }

  changeHeaderFixedLayout(flag: boolean) {
    if (flag) {
      document.querySelector('.pcoded-header')?.classList.add('headerPos-fixed');
    } else {
      document.querySelector('.pcoded-header')?.classList.remove('headerPos-fixed');
      // static
      if (GradientConfig.layout === 'vertical' && GradientConfig.nav_fixed_layout) {
        window.addEventListener('scroll', this.scroll, true);
        window.scrollTo(0, 0);
      } else {
        window.removeEventListener('scroll', this.scroll, true);
      }
    }
  }

  setBoxLayout(e: Event) {
    const flag = (e.target as HTMLInputElement).checked;
    this.changeBoxLayout(flag);
  }

  changeBoxLayout(flag: boolean) {
    if (flag) {
      document.querySelector('body')?.classList.add('container');
      document.querySelector('body')?.classList.add('box-layout');
    } else {
      document.querySelector('body')?.classList.remove('box-layout');
      document.querySelector('body')?.classList.remove('container');
    }
  }

  setHeaderBackground(background: string) {
    document.querySelector('.pcoded-header')?.classList.remove('header-blue');
    document.querySelector('.pcoded-header')?.classList.remove('header-red');
    document.querySelector('.pcoded-header')?.classList.remove('header-purple');
    document.querySelector('.pcoded-header')?.classList.remove('header-info');
    document.querySelector('.pcoded-header')?.classList.remove('header-dark');
    document.querySelector('.pcoded-header')?.classList.remove('header-orange');
    document.querySelector('.pcoded-header')?.classList.remove('header-green');
    document.querySelector('.pcoded-header')?.classList.remove('header-yellow');
    document.querySelector('.pcoded-header')?.classList.remove('header-orchidGreen');
    document.querySelector('.pcoded-header')?.classList.remove('header-indigoGreen');
    document.querySelector('.pcoded-header')?.classList.remove('header-darkGreen');
    document.querySelector('.pcoded-header')?.classList.remove('header-darkblue');

    if (background !== 'header-default') {
      document.querySelector('.pcoded-header')?.classList.add(background);
    }
  }
}
